import { LoadingButton } from '@mui/lab';
import { Box, Button, Checkbox, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Modal from '../../components/Modal';
import { Add } from '@mui/icons-material';
import CheckedIcon from '../../icons/CheckedIcon';
import UnCheckIcon from '../../icons/UnCheckIcon';
import { post } from '../../api';
import { PaymentIcon } from 'react-svg-credit-card-payment-icons';
import NoDataPresentUI from '../../components/NoDataPresentUI';
import BlankIcon from '../../icons/BlankIcon';
import { updatePaymentSkeleton } from './skeleton';

const CONSTANTS_CARD_LIST = [
    {
        id: '0001',
        cardHolderName: 'Relay',
        img: '/images/other/Payment-method-icon.svg',
        cardInfo: 'Visa ending in 1234',
        cardExpriration: 'Expiry 06/2024',
        isChecked: true,
    },
    {
        id: '0002',
        cardHolderName: 'Relay',
        img: '/images/other/Payment-method-icon.svg',
        cardInfo: 'Visa ending in 1234',
        cardExpriration: 'Expiry 06/2024',
        isChecked: false,
    },
];
function UpdatePayment({ addPaymentModalOpen, contactId, selectedPaymentMethodId, onPaymentMethodUpdate, keyData }) {
    const [cardList, setCardList] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(selectedPaymentMethodId);

    const [loading, setLoading] = useState(false);

    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [mapByDataLocal, setMapByDataLocal] = useState({});

    const handleUpdateModalClose = () => {
        setIsUpdateModalOpen(false);
    };
    const handleUpdateModalOnUpdate = () => {
        setIsUpdateModalOpen(false);
        onPaymentMethodUpdate(selectedCard);
    };

    const handleUpdateModalOpen = () => {
        setIsUpdateModalOpen(true);
    };

    const getKey = (item) => {
        return item.cardExpirationMonth + item.cardExpirationYear + item.cardLast4 + item.cardType;
    };

    useEffect(() => {
        if (isUpdateModalOpen) {
            setCardList([]);
            setSelectedCard(null);
            setLoading(true);
            post('custom/getPaymentMethodDetails', { contactId: contactId }).then((result) => {
                if (result.isSuccess) {
                    let cardLists = [];
                    let mapByData = {};
                    if (result.data?.length > 0) {
                        for (let item of result.data) {
                            let key = getKey(item);
                            if (!mapByData[key]) {
                                cardLists.push(item);
                                mapByData[key] = [];
                            }
                            mapByData[key].push(item);

                            if (keyData === key) {
                                setSelectedCard(mapByData[key][0]);
                                setSelectedPaymentMethod(mapByData[key][0].id);
                            }
                        }
                        setMapByDataLocal(mapByData);
                    }

                    setCardList(cardLists);
                    // if (selectedPaymentMethodId) {
                    //     setSelectedCard(result.data.find((item) => item.id === selectedPaymentMethodId));
                    // }
                }
                setLoading(false);
            });
        }
    }, [isUpdateModalOpen]);

    const handleCardSelect = (cCardDetails) => {
        setSelectedCard(cCardDetails);
    };

    useEffect(() => {
        // Add the event listener
        window.addEventListener('UPDATE_PAYMENT_MODAL_OPEN', handleUpdateModalOpen);

        // Cleanup function to remove the event listener
        return () => {
            window.removeEventListener('UPDATE_PAYMENT_MODAL_OPEN', handleUpdateModalOpen);
        };
    }, []);

    return (
        <>
            {/* Update Payment Method */}
            <Modal
                modalOpen={isUpdateModalOpen}
                title="Update payment method"
                hideActions={false}
                handleModalClose={handleUpdateModalClose}
                SubmitBtnUI={
                    <LoadingButton type="button" variant="contained" onClick={handleUpdateModalOnUpdate}>
                        Update
                    </LoadingButton>
                }
                PaperProps={{
                    component: 'form',
                    sx: {
                        maxWidth: 500,

                        '@media (max-width:425px)': {
                            margin: '1rem',
                        },
                    },
                }}
            >
                {loading && updatePaymentSkeleton}
                {!loading && (
                    <Box>
                        {cardList.length === 0 && (
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <NoDataPresentUI
                                    containerSx={{
                                        width: {
                                            xs: '100%',
                                            sm: '100%',
                                            md: '60%',
                                        },
                                    }}
                                    heading="No payment method found."
                                    icon={<BlankIcon />}
                                />
                                <Button
                                    onClick={() => {
                                        handleUpdateModalClose();
                                        addPaymentModalOpen();
                                    }}
                                    startIcon={<Add />}
                                >
                                    Add new payment method
                                </Button>
                            </Box>
                        )}
                        {cardList.length > 0 && (
                            <Box>
                                <Typography
                                    component={'h2'}
                                    color={'text.primary'}
                                    textAlign={'start'}
                                    fontSize={'customFontSize.medium'}
                                    fontWeight={'fontWeightSemiBold'}
                                    lineHeight={'normal'}
                                    marginBottom={'0.8rem'}
                                >
                                    Existing Payment Method
                                </Typography>

                                <List
                                    sx={{
                                        '& .MuiListItem-root': {
                                            // padding: 0,
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                        },

                                        '& .MuiButtonBase-root.MuiListItemButton-root': {
                                            border: '1px solid #EAECF0',
                                            borderRadius: '8px',
                                            padding: '1rem',

                                            display: 'flex',
                                            alignItems: 'flex-start',

                                            '&.Mui-selected': {
                                                border: '1px solid #014DE5',
                                            },
                                        },

                                        '& .MuiListItemSecondaryAction-root': {
                                            top: '30px',
                                            transform: 'translateY(-20%)',
                                        },

                                        '& .MuiAvatar-root': {
                                            borderRadius: '10px',
                                            height: '40px',
                                            width: '45px',
                                        },

                                        '& .MuiListItemText-root': {
                                            margin: 0,
                                        },
                                    }}
                                >
                                    {cardList.map((cCardDetails) => (
                                        <ListItem
                                            alignItems="center"
                                            secondaryAction={
                                                <Checkbox
                                                    onClick={() => {
                                                        handleCardSelect(cCardDetails);
                                                    }}
                                                    checked={cCardDetails.id === selectedCard?.id}
                                                    edge="end"
                                                    checkedIcon={<CheckedIcon sx={{ color: '#014DE5' }} />}
                                                    icon={<UnCheckIcon sx={{ color: '#D0D5DD' }} />}
                                                />
                                            }
                                        >
                                            <ListItemButton
                                                selected={cCardDetails.id === selectedCard?.id}
                                                onClick={() => {
                                                    handleCardSelect(cCardDetails);
                                                }}
                                            >
                                                <ListItemAvatar>
                                                    <PaymentIcon type={cCardDetails.cardType?.toLowerCase()} format="flatRounded" width={50} />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={`Visa ending in ${cCardDetails.cardLast4}`}
                                                    secondary={
                                                        <React.Fragment>
                                                            <Typography component="span" variant="body2" sx={{ color: cCardDetails.ccExpiringSoon ? 'red' : 'text.primary', display: 'inline' }}>
                                                                {`Exp. ${cCardDetails.cardExpirationMonth}/${cCardDetails.cardExpirationYear}`}
                                                            </Typography>
                                                        </React.Fragment>
                                                    }
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                                <Button
                                    onClick={() => {
                                        handleUpdateModalClose();
                                        addPaymentModalOpen();
                                    }}
                                    startIcon={<Add />}
                                >
                                    Add new payment method
                                </Button>
                            </Box>
                        )}
                    </Box>
                )}
            </Modal>
        </>
    );
}

export default UpdatePayment;
